import * as React from 'react';
import { observer } from 'mobx-react';
import { useLocation } from 'react-router-dom';
import { DeviceType } from '@ixicare/resources';
import { getCurrentLanguage } from '~/i18n';
import { resolveHelp } from '~config/helpCenter';
import { useStores } from '~store/utils';
import styles from './HelpLink.module.css';

const HelpLink: React.FC = observer(() => {
  const { pathname } = useLocation();
  const { devices } = useStores();
  // Tabs write the hash with history.replaceState, which the router doesn't see, so read it again
  // when the link is about to be used.
  const [hash, setHash] = React.useState(window.location.hash);
  const refreshHash = () => setHash(window.location.hash);
  const deviceType = devices.schemaKey?.split(':')[0] as DeviceType | undefined;
  const { href, label } = resolveHelp(pathname, hash, getCurrentLanguage(), deviceType);
  return (
    <a
      className={styles.HelpLink}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      onMouseEnter={refreshHash}
      onFocus={refreshHash}
      onClick={(event) => {
        event.currentTarget.href = resolveHelp(pathname, window.location.hash, getCurrentLanguage(), deviceType).href;
      }}
    >
      <i className={`icon-question ${styles.Mark}`} aria-hidden />
      <span className={styles.Tooltip} role="tooltip">
        {label}
      </span>
    </a>
  );
});

export default HelpLink;
